/**
 * Enum para identificar `key` registradas en el localStorage 
*/
export enum Storage {
    /**
     * Token
    */
    Token = 'token',
    /**
     * Response Registro Flow
    */
    ResponseRegistroFlow = 'ResponseRegistroFlow',
    /**
     * Form Registro
    */
    FormRegistro = 'formRegistro',

    UsuarioData = 'user_data',
    
    /** Campo a tener en cuenta para saber si se mostrara el tour guiado */
    TOUR_GUIADO = 'tourGuiado',
}

/**
 * Claves para localStorage
 */
export enum StorageKeys {
  /** Token de acceso */
  ACCESS_TOKEN = 'access_token',
  
  /** Token de actualización */
  REFRESH_TOKEN = 'refresh_token',
  
  /** Fecha de expiración */
  EXPIRES_AT = 'expires_at',
  
  /** Datos del usuario */
  USER_DATA = 'user_data',
  
  /** Perfil seleccionado del usuario */
  PERFIL = 'perfil',
  
  /** Datos del formulario de registro ?? registrar que ?? */
  FORM_REGISTRO = 'formRegistro',
  
  /** Campo a tener en cuenta para saber si se mostrara el tour guiado */
  TOUR_GUIADO = 'tourGuiado',
  /**
   * Response Registro Flow
  */
  RESPONSE_REGISTRO_FLOW = 'responseRegistroFlow',
  /**
   * Estado mock del Buzon Judicial
  */
  BUZON_JUDICIAL_STATE = 'buzonJudicialState',

  /** Bandera para mostrar el aviso de Buzón Judicial justo después del post-login */
  SHOW_BUZON_JUDICIAL_NOTICE = 'showBuzonJudicialNotice',
}

/**
 * Claves para sessionStorage (sobreviven a la recarga del navegador y se descartan al cerrar la pestaña).
 * El flujo de depósito (recepción) de caso/trámite vive aquí para que cada pestaña tenga su propio flujo
 */
export enum SessionStorageKeys {
  /** Datos de recepción */
  RECEPCION_DATA = 'recepcionData',

  /** Recepcion Form Values */
  RECEPCION_FORM_VALUES = 'recepcionFormValues',

  /** Última búsqueda de alguacil del step Recepción */
  ALGUACIL = 'queryAlguacil',

  /** Data a tener en cuenta para saber si se puede mostrar el step de fijacion */
  RECEPCION_FIJA_AUDIENCIA = 'recepcionFijaAudiencia',

  /** Estado del stepper de recepción (paso actual, archivos y partes) para restaurarlo al recargar */
  RECEPCION_STEPPER_STATE = 'recepcionStepperState',

  /** State de navegación del formulario de recepción (caso/trámite) por si se pierde al recargar */
  RECEPCION_LOCATION_STATE = 'recepcionLocationState',

  /** Operación no idempotente en curso (crear recepción, verificar, fijar audiencia) para detectar si una recarga la interrumpió */
  RECEPCION_OPERACION_EN_CURSO = 'recepcionOperacionEnCurso',
}
